import React from "react";
import { ApiResource, MonsterDto } from "../Types/ApiTypes";
import { getAllMonsters } from "../Utils/LocalApi";



export const AllMonstersContext = React.createContext<MonsterDto[]>([]);

const AllMonstersProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
    const [allMonsters, setAllMonsters] = React.useState<MonsterDto[]>([]);
      
      if (allMonsters.length === 0)
          getAllMonsters().then(setAllMonsters);

    return (
        <AllMonstersContext.Provider value={allMonsters}>
          {children}
        </AllMonstersContext.Provider>
      );
};

export default AllMonstersProvider;